import ApiDefault from "../../ApiDefault";

export default function ApiAttributes() {
    const apiDefault = ApiDefault("v2/system/attributes");

    return {
        apiDefault,
    };
}
